import { useRouter } from 'vue-router'
import { useIntegrator } from '@nsftx/seven-client-retail-vue-integrator'
import { logService } from '@nsftx/seven-client-retail-utils'
import { ROUTES_NAMES } from '@/router/routesNames'
import { useNotificationsStore } from '@nsftx/seven-nxg-retail-vue-sdk'
import errorParser from '@/utils/errorParser'
import { useI18n } from 'vue-i18n'

interface UseSlipRebetOptions {
  linkCode: string
  feBetslipId: string
  betIds: string[]
}

const LOG_PREFIX = '[useSlipRebet]'

export const useSlipRebet = () => {
  const router = useRouter()
  const { rebet } = useIntegrator()
  const { t } = useI18n({ useScope: 'global' })

  const rebetSlip = async (options: UseSlipRebetOptions) => {
    const { linkCode, feBetslipId, betIds } = options

    try {
      await router.push({ name: ROUTES_NAMES.game, params: { gameId: linkCode } })
      rebet(feBetslipId, betIds, { linkCode })
      logService.debug(`${LOG_PREFIX} Slip rebet action was successful.`, {
        code: 'SS_SLIP_REBET_SUCCESS',
        product_displayid: linkCode,
        feBetslipId,
        details: {
          betIds,
        },
      })
    } catch (error) {
      const { showNotification } = useNotificationsStore()
      logService.error(`${LOG_PREFIX} Slip rebet action has failed.`, {
        ...errorParser.parseUpstream(error),
        code: 'SS_SLIP_REBET_ERROR',
        feBetslipId: feBetslipId,
        product_displayid: linkCode,
        details: {
          betIds,
        },
      })
      showNotification({
        variant: 'error',
        text: [t('slip_rebet_failed')],
      })
    }
  }

  return { rebetSlip }
}
